import EmailInput from "components/EmailInput"
import VueComponent from "../vue_component"

export default VueComponent(EmailInput)
